import React, { FunctionComponent } from "react";

import { SeasonNumberAsString } from "../../queries/useSearchTiresByVehicle";
import { PartlyCloudyIcon } from "./PartlyCloudyIcon";
import { SnowflakeIcon } from "./SnowflakeIcon";
import { SunIcon } from "./SunIcon";

type SeasonIconProps = {
  season: SeasonNumberAsString;
};

const map = {
  "0": SnowflakeIcon,
  "1": PartlyCloudyIcon,
  "2": SunIcon,
};

export const SeasonIcon: FunctionComponent<SeasonIconProps> = ({ season }) => {
  const Component = map[season] || map["1"];
  return <Component />;
};
